import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import { typography } from '../../../../styles/theme';
import {
  UF_BUILDING_TYPE_EMPTY_STATE_ICONS,
  UF_BUILDING_TYPE_ICON_SX,
  UF_BUILDING_TYPE_ICON_TILE_SX,
} from '../../../utils/ufBuildingTypeIcons';

const PROPERTY_TYPE_ICONS = UF_BUILDING_TYPE_EMPTY_STATE_ICONS;

const UF_EMPTY_STATE_BOX_SX = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  width: '100%',
  minHeight: 280,
  px: 3,
  py: 4,
  textAlign: 'center',
  gap: '20px',
};

const UF_EMPTY_STATE_ICON_ROW_SX = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '20px',
  mb: 2,
};

const UF_EMPTY_STATE_ICON_TILE_SX = UF_BUILDING_TYPE_ICON_TILE_SX;

const UF_EMPTY_STATE_ICON_SX = UF_BUILDING_TYPE_ICON_SX;

const PRIMARY_ON = '#E8F4F4';

const UF_EMPTY_STATE_TITLE_SX = {
  color: '#d4d4d4',
  fontFamily: typography.fontFamily.heading,
  fontWeight: typography.fontWeight.semibold,
  fontSize: '16px',
  lineHeight: '19px',
  letterSpacing: 0,
  textAlign: 'center',
  verticalAlign: 'middle',
  maxWidth: 300,
  mb: -1,
};

const UF_EMPTY_STATE_HINT_SX = {
  color: '#ababab',
  fontFamily: typography.fontFamily.primary,
  fontWeight: typography.fontWeight.regular,
  fontSize: '14px',
  lineHeight: '19px',
  letterSpacing: 0,
  textAlign: 'center',
  verticalAlign: 'middle',
  maxWidth: 320,
};

const UF_EMPTY_STATE_CTA_SX = {
  textTransform: 'none',
  mt: 2.5,
  px: 2.75,
  minHeight: 44,
  height: 44,
  minWidth: 166,
  fontFamily: typography.fontFamily.primary,
  fontSize: '16px',
  fontWeight: typography.fontWeight.medium,
  lineHeight: '18.41px',
  letterSpacing: 0,
  borderRadius: '8px',
  color: PRIMARY_ON,
  border: `1px solid ${PRIMARY_ON}`,
  bgcolor: 'transparent',
  boxShadow: 'none',
  gap: 1,
  '&:hover': {
    bgcolor: 'rgba(232,244,244,0.06)',
    borderColor: PRIMARY_ON,
    boxShadow: 'none',
  },
  '& .MuiButton-startIcon': {
    margin: 0,
    marginRight: '8px',
  },
};

const UF_EMPTY_STATE_CTA_ICON_SX = {
  width: 24,
  height: 24,
  fontSize: '24px !important',
  color: PRIMARY_ON,
};

const UfEmptyState = ({ onAdd, showAction = true }) => (
  <Box sx={UF_EMPTY_STATE_BOX_SX}>
    <Box sx={UF_EMPTY_STATE_ICON_ROW_SX} aria-hidden>
      {PROPERTY_TYPE_ICONS.map((Icon, index) => (
        <Box key={index} sx={UF_EMPTY_STATE_ICON_TILE_SX}>
          <Icon sx={UF_EMPTY_STATE_ICON_SX} />
        </Box>
      ))}
    </Box>

    <Typography sx={UF_EMPTY_STATE_TITLE_SX}>
      Sin propiedades registradas
    </Typography>

    <Typography sx={UF_EMPTY_STATE_HINT_SX}>
      Las unidades funcionales representan construcciones o divisiones dentro del lote:
      casas, departamentos, locales comerciales, galpones, etc.
    </Typography>

    {showAction && onAdd && (
      <Button
        onClick={onAdd}
        startIcon={<ControlPointIcon sx={UF_EMPTY_STATE_CTA_ICON_SX} />}
        sx={UF_EMPTY_STATE_CTA_SX}
      >
        Agregar unidad
      </Button>
    )}
  </Box>
);

export default UfEmptyState;
